module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/2_fd64dbd7c738d3cc51d8712279ff5e57.png";